
export default function WhyChooseUs() {
  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="w-48 h-48 mx-auto mb-8 rounded-full overflow-hidden shadow-xl border-4 border-sky-500">
            <img
              src="https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F9e456e31583c47d3929b4a75d0402cec&methods=resize%2C1000%2C5000"
              alt="Stairs and landing painting services"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Why Are We Recommended Painters and Decorators?
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed max-w-4xl mx-auto">
            Careful preparation, expert application, final detailing, and thorough clean-up are all part of our work process to deliver the quality results you expect. We care about your peace of mind and are committed to your complete satisfaction. Brushour Painters and Decorators guarantees every project is completed as contracted. Our customers trust us as their painters and call us again and again. We begin every project with the end result in mind, and that result is a quality product and, most of all, your complete satisfaction. As painters and decorators, we provide a detailed and complete estimate and answer any of your questions. All necessary products and labour to complete your project can be included in your quote, so you can be assured of no hidden fees and no surprise up-charges. These are some of the reasons we are a professional painting business and highly recommended painters and decorators in the Watford area.
          </p>
        </div>

        <div className="mt-16 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-sky-500 to-teal-400 rounded-2xl transform -rotate-1"></div>
          <div className="relative bg-white rounded-2xl shadow-xl p-10 transform rotate-0">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8">
              <div className="relative">
                <div className="absolute -inset-3 bg-gradient-to-r from-sky-400 to-teal-400 rounded-full opacity-20 blur-lg"></div>
                <div className="relative w-28 h-28 rounded-full overflow-hidden border-4 border-sky-500 shadow-lg">
                  <img
                    src="https://public.readdy.ai/ai/img_res/02fb86369698583ff3d53cac19682e47.jpg"
                    alt="Top painters in Watford award badge"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
              <div className="text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                  <i className="ri-award-fill text-2xl text-amber-500"></i>
                  <span className="text-sm font-medium text-gray-500 uppercase tracking-wider">Award Winner</span>
                </div>
                <p className="text-2xl md:text-3xl font-bold text-gray-800">
                  "Top 3 Best Painters and Decorators in Watford"
                </p>
                <p className="text-gray-500 mt-2">Recognised for excellence in quality and customer satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
